import backofficeService from '../../api/backoffice'

export default {
	getAtttendanceForReport(params) {
    return backofficeService.Api().get('attendance/report', {
        params
      })
      .then(response => response.data)
      .catch(error => {
        throw error
      })
  },
	getAtttendanceDetailForReport(params) {
    return backofficeService.Api().get('attendanceDetail/report', {
        params
      })
      .then(response => response.data)
      .catch(error => {
        throw error
      })
  },
  getAll(params) {
    return backofficeService.Api().get('attendance', {
        params
      })
      .then(response => response.data)
      .catch(error => {
        throw error
      })
  },
  getById(id, params) {
    return backofficeService.Api().get(`attendance/${id}`, {
        params
      })
      .then(response => response.data)
      .catch(error => {
        throw error
      })
  },
  create(data) {
    return backofficeService.Api().post('attendance', data)
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  attendanceInfo(params) {
    return backofficeService.Api().get('attendance/info/bystudent', {
        params
      })
      .then(response => response.data)
      .catch(error => {
        throw error
      })
  },
  createDetail(data) {
    return backofficeService.Api().post('attendanceDetail', data)
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
}